import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { IoIosInformationCircleOutline } from "react-icons/io";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  questionnaireComponents,
  inputFields,
  Loader,
  popover,
} from "../../components";

import { UtilityArrays, Utils } from "../../config";

import "./styles.css";

const Education = ({ setPage }) => {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);

  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    expectedGradYear: null,
    curriculum: null,
  });

  useEffect(() => {
    setState({
      expectedGradYear: questionnaire?.expectedGradYear ?? null,
      curriculum: questionnaire?.curriculum ?? null,
    });
  }, [questionnaire]);
  const handleNext = () => {
    if (!state.curriculum) {
      message.error("Please fill all the fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            setPage("High School Grades");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <div>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6 max-h-[34.375em] overflow-y-auto">
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Current School"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Dubai School"
                value={
                  profileData?.schoolName ??
                  `${profileData?.student?.school?.userId?.firstName} ${profileData?.student?.school?.userId?.lastName}`
                }
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Current Grade"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="grade"
                value={profileData?.student?.grade}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Expected Graduation Year" />
              <Spacer height={5} />
              <inputFields.SelectDropdown
                onChange={(e) => setState({ ...state, expectedGradYear: e })}
                items={Utils.filterArray(UtilityArrays.gradYearsArray)}
                placeholder="Select your graduation year"
                value={state?.expectedGradYear}
              />
            </div>
            <div>
              <div className="flex gap-2 items-center">
                <questionnaireComponents.QuestionnaireLabel
                  text="Curriculum"
                  required
                />
                <span>
                  <popover.WhitePopover
                    content={
                      <div className="text-[14px] font-medium">
                        Please specify the current <br /> education
                        qualification
                        <br />
                        that you are pursuing
                      </div>
                    }
                    trigger="hover"
                    placement="right"
                  >
                    <IoIosInformationCircleOutline className="text-main" />
                  </popover.WhitePopover>
                </span>
              </div>
              <Spacer height={5} />
              <inputFields.SelectDropdown
                onChange={(e) => setState({ ...state, curriculum: e })}
                items={Utils.filterArray(UtilityArrays.curriculum)}
                placeholder="Select your curriculum"
                value={state?.curriculum}
              />
            </div>
          </div>
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Education;
